/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{addDomEvent as o}from"./add-dom-event.js";import{addPointerInfo as r}from"./event-info.js";function t(t,e,n,m){return o(t,e,r(n),m)}export{t as addPointerEvent};
//# sourceMappingURL=add-pointer-event.js.map
